'use client';

import Pagination from '@/components/pagination';
import { AcademyEntity } from '@/services/types/academy.type';
import AcademyCard from './academy-card';

interface Props {
  academies: AcademyEntity[];
  pageSize?: number;
  totalCount?: number;
  page: number;
  onPageChange: (page: number) => void;
}

const AcademyGrid = ({
  academies,
  pageSize = 10,
  totalCount = 0,
  page,
  onPageChange,
}: Props) => {
  const totalPages = Math.ceil(totalCount / pageSize);

  if (totalCount == 0) {
    return (
      <div className="pt-15 pb-40">
        <div className="text-level-6 typo-16 text-center font-semibold">
          학원 데이터가 없습니다.
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="desktop:grid-cols-2 desktop:gap-x-5 desktop:gap-y-5 grid w-full grid-cols-1 gap-y-5">
        {academies.map((academy) => (
          <AcademyCard {...academy} key={'academy' + academy.id} />
        ))}
      </div>
      <Pagination
        page={page}
        totalPages={totalPages}
        onPageChange={onPageChange}
      />
    </>
  );
};

export default AcademyGrid;
